import { render, staticRenderFns } from "./tianBaoIndex.vue?vue&type=template&id=1610b22a&scoped=true&"
import script from "./tianBaoIndex.vue?vue&type=script&lang=js&"
export * from "./tianBaoIndex.vue?vue&type=script&lang=js&"
import style0 from "./tianBaoIndex.vue?vue&type=style&index=0&id=1610b22a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610b22a",
  null
  
)

export default component.exports